module.exports = "<h2 (click)=\"onClick.emit()\">{{ text }}</h2>";